import "./SendDocs.css";
import Report from "../../Components/Report/Report";
import MyBroadcasts from "./MyBroadcasts";
import HeaderSendDocs from "./HeaderSendDocs";
import SendNewDocButton from "./SendNewDocButton";

export default function SendDocs () {
    return (
        <div>
            <div className="SendDocs">
                <HeaderSendDocs></HeaderSendDocs>
                <MyBroadcasts></MyBroadcasts>
                <SendNewDocButton></SendNewDocButton>
            </div>
            <Report></Report>
        </div>
    )
}